import { jsx } from "react/jsx-runtime";
import "react";
import lite from "clsx/lite";
import { HeadingSize, HeadingWeight } from "./types.mjs";
const Heading = ({ as, size, weight = 'regular', children, className, ...props })=>{
    const RootHeading = as;
    return /*#__PURE__*/ jsx(RootHeading, {
        ...props,
        className: lite(HeadingSize[size], HeadingWeight[weight], className),
        children: children
    });
};
export { Heading };
